window.addEventListener('load', function() {
    const userEl = document.querySelector('.users-section');
    if (userEl) {
        const UserManager = require('../modules/Users');
        var mod = new UserManager(userEl, {});
    }
});
